export const GROOM_STRUCTURED_SUBCATEGORIES = [
  'Suits',
  'Tuxedos',
  'Blazers',
  'Dress Shirts',
];

export const GROOM_SUIT_OPTIONS = {
  suit_type: ['Classic Suit', 'Tuxedo', 'Blazer + Trouser', 'Three-Piece Suit', 'Dress Shirt', 'Other'],
  fit: ['Slim fit', 'Tailored fit', 'Regular fit', 'Relaxed fit', 'Custom', 'Other'],
  lapel: ['Notch', 'Peak', 'Shawl', 'Mandarin', 'None', 'Other'],
  closure: ['Single-breasted', 'Double-breasted', 'Button-down', 'Zip', 'Other'],
  pant_style: ['Flat front', 'Pleated', 'Slim leg', 'Straight leg', 'Tapered', 'No pants included', 'Other'],
  vibe: ['Classic', 'Modern', 'Minimal', 'Royal', 'Vintage', 'Bold', 'Other'],
  main_fabric: ['Wool', 'Cotton', 'Linen', 'Velvet', 'Tweed', 'Poly-blend', 'Satin', 'Other'],
  pattern: ['Solid', 'Pinstripe', 'Checkered', 'Textured', 'Paisley', 'Other'],
  color: ['Black', 'Charcoal', 'Navy', 'Midnight Blue', 'Grey', 'Light Grey', 'Brown', 'Tan', 'White', 'Ivory', 'Burgundy', 'Emerald', 'Custom'],
  size_label: ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'Custom', 'Unknown'],
  adjustability: ['Altered', 'Stretch fabric', 'Expandable waist', 'Not adjustable'],
  weight_class: ['Light', 'Medium', 'Heavy'],
  mobility: ['Yes', 'Somewhat', 'No'],
  danceable: ['Yes', 'No'],
  included_items: ['Jacket', 'Pants', 'Vest', 'Shirt', 'Tie', 'Bow Tie', 'Pocket Square', 'Cufflinks', 'None'],
};

export const EMPTY_GROOM_SUIT_FORM = {
  suit_type: '',
  fit: '',
  lapel: '',
  closure: '',
  pant_style: '',
  vibe: '',
  main_fabric: '',
  pattern: '',
  color: '',
  chest_cm: '',
  waist_cm: '',
  shoulder_cm: '',
  sleeve_cm: '',
  trouser_waist_in: '',
  trouser_length_in: '',
  height_cm: '',
  weight_range_kg: '',
  size_label: '',
  adjustability: '',
  weight_class: '',
  mobility: '',
  danceable: '',
  flaws: '',
  sale_price: '',
  included_items: [],
};

const norm = (value) => String(value || '').trim().toLowerCase();
const normalizeToOption = (value, options) => {
  if (!value) return '';
  const exact = options.find((o) => norm(o) === norm(value));
  if (exact) return exact;
  const fallback = options.find((o) => norm(value).includes(norm(o)) || norm(o).includes(norm(value)));
  return fallback || value;
};

export const buildGroomSuitJson = ({ formData, groomData, imageNames }) => ({
  title: formData.title || '',
  occasion: formData.subcategory || 'Groom Suit',
  condition: formData.condition || '',
  availability: formData.in_stock || '1',
  style: {
    silhouette: normalizeToOption(groomData.suit_type, GROOM_SUIT_OPTIONS.suit_type),
    neckline: '',
    sleeves: '',
    back: normalizeToOption(groomData.lapel, GROOM_SUIT_OPTIONS.lapel),
    train: '',
    vibe: normalizeToOption(groomData.vibe, GROOM_SUIT_OPTIONS.vibe),
  },
  fabric: {
    main: normalizeToOption(groomData.main_fabric, GROOM_SUIT_OPTIONS.main_fabric),
    lining: normalizeToOption(groomData.pattern, GROOM_SUIT_OPTIONS.pattern),
    embellishments: [],
    color: normalizeToOption(groomData.color, GROOM_SUIT_OPTIONS.color),
  },
  measurements: {
    bust: groomData.chest_cm || '',
    waist: groomData.waist_cm || '',
    shoulder: groomData.shoulder_cm || '',
    sleeve: groomData.sleeve_cm || '',
    trouser_waist_in: groomData.trouser_waist_in || '',
    trouser_length_in: groomData.trouser_length_in || '',
    hips: '',
    height: groomData.height_cm || '',
    weight_range: groomData.weight_range_kg || '',
    size: normalizeToOption(groomData.size_label, GROOM_SUIT_OPTIONS.size_label),
    adjustability: normalizeToOption(groomData.adjustability, GROOM_SUIT_OPTIONS.adjustability),
  },
  comfort: {
    weight: normalizeToOption(groomData.weight_class, GROOM_SUIT_OPTIONS.weight_class),
    mobility: normalizeToOption(groomData.mobility, GROOM_SUIT_OPTIONS.mobility),
    danceable: normalizeToOption(groomData.danceable, GROOM_SUIT_OPTIONS.danceable),
    flaws: groomData.flaws || '',
  },
  pricing: {
    rental_price: '',
    sale_price: groomData.sale_price || '',
    deposit: '',
    cleaning_policy: '',
  },
  logistics: {
    try_on: '',
    delivery: '',
  },
  extras: (groomData.included_items || []).map((v) => normalizeToOption(v, GROOM_SUIT_OPTIONS.included_items)),
  photos: imageNames || [],
});
